<script setup lang="ts">
import Textarea from 'primevue/textarea'

interface Props {
  modelValue?: string | null
  placeholder?: string
  disabled?: boolean
  invalid?: boolean
  rows?: number
  autoResize?: boolean
  /** Hard cap on the number of characters the user can enter. */
  maxlength?: number
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  disabled: false,
  invalid: false,
  rows: 4,
  autoResize: false,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'blur', event: FocusEvent): void
}>()

function handleUpdate(value: string | undefined) {
  emit('update:modelValue', value ?? '')
}
</script>

<template>
  <Textarea
    class="base-textarea"
    :modelValue="props.modelValue ?? ''"
    :placeholder="placeholder"
    :disabled="disabled"
    :invalid="invalid"
    :rows="rows"
    :maxlength="maxlength"
    :autoResize="autoResize"
    @update:modelValue="handleUpdate"
    @blur="(e) => emit('blur', e)"
  />
</template>

<style scoped>
.base-textarea.p-textarea {
  border-radius: var(--p-border-radius-md);
  padding: 0.625rem 0.875rem;
  font-family: inherit;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.5;
  resize: vertical;
}
</style>
